import {getBootstrapData} from '@common/core/bootstrap-data/use-backend-bootstrap-data';

/**
 * Whether the phone password + OTP mode is enabled on this deployment. Mirrors
 * the server-side Common\Auth\PhoneAuth\PhoneAuthMode. When false, the legacy
 * passwordless phone flow is used unchanged.
 */
export function phonePasswordOtpEnabled(): boolean {
  return getBootstrapData().settings.auth?.phone_password_otp === true;
}
